import React from "react";
import "./MeetMerchant.css";

function MeetMerchant() {
  return (
    <div className="meet-merchants">
      <h1>Meet Our Merchants</h1>
      <img
        src="https://res.cloudinary.com/teb/image/upload/v1671004943/Handdrawn_vector_fvblaz.png"
        alt=""
        className="meet-merchants-img"
      />
      <div className="meet-merchants-container">
        <div className="meet-merchant-box">
          <img src="/assets/Image (6).png" alt="" />
          <h1>Daramola Onopemipo</h1>
          <p>COO - Arabella Beauty Affairs</p>
        </div>
        <div className="meet-merchant-box">
        <img src="/assets/gizmo 2 1.png" alt="" />
          <h1>Ibiyinka Lawal</h1>
          <p>Founder - Gizmo Stores</p>
        </div>
        <div className="meet-merchant-box">
          <img src="/assets/Image.webp" alt="" />
          <h1>Olubukola Adekunle</h1>
          <p>Founder - Lela’s Foodmart</p>
        </div>
        <div className="meet-merchant-box">
          <img src="/assets/Image (1).webp" alt="" />
          <h1>Temitope Modupe</h1>
          <p>Founder - Thames Spice Haven</p>
        </div>
        <div className="meet-merchant-box">
        <img src="/assets/Image (7).png" alt="" />
          <h1>Kema Abuede (Cakepriest)</h1>
          <p> Founder - Conspicuous Cakes</p>
        </div>
        <div className="meet-merchant-box">
          <img src="/assets/Image (2).webp" alt="" />
          <h1>Gbenga Adetunji</h1>
          <p>Founder & Creative Director - Adebadol</p>
        </div>
        <div className="meet-merchant-box">
        <img src="/assets/Image (8).png" alt="" />
          <h1>Binta Doga</h1>
          <p>Founder - BFH Designs</p>
        </div>
      </div>
    </div>
  );
}

export default MeetMerchant;
